export class InMemoryStore implements Storage {
	private data: { [key: string]: string } = {};

	length = 0;

	setItem = (key: string, value: string): string => {
		this.data[key] = value;
		this.length = Object.keys(this.data).length;
		return value;
	};

	getItem = (key: string): string | null => {
		if (key in this.data) {
			return this.data[key];
		}
		return null;
	};

	removeItem = (key: string) => {
		if (key in this.data) {
			delete this.data[key];
		}
		this.length = Object.keys(this.data).length;
		return null;
	};

	clear = (): void => {
		this.data = {};
		this.length = 0;
	};

	key = (index: number): string => Object.keys(this.data)[index];
}

// eslint-disable-next-line import/no-anonymous-default-export
const inmemorystorage: InMemoryStore = new InMemoryStore();
export default inmemorystorage;
